export const SYSTEM_ROLES = [
  { id: 'admin', name: 'Admin' },
  { id: 'manager', name: 'Manager' },
  { id: 'user', name: 'Employee' },
];

export const USER_STATUSES = [
  { id: 'joined', name: 'Joined' },
  { id: 'invited', name: 'Invited' },
  { id: 'notInvited', name: 'Not invited' },
  { id: 'unverified', name: 'Unverified' },
  { id: 'notInvitedNoEmail', name: 'No email' },
];
